import withImmutableActions from "neetocommons/react-utils/withImmutableActions";
import { create } from "zustand";

/** @type {import("neetocommons/react-utils").ZustandStoreHook} */
const useKeyboardShortcutsStore = create(
  withImmutableActions(set => ({
    isOpen: false,

    setIsOpen: arg => {
      if (typeof arg === "function") {
        set(state => ({ isOpen: arg(state.isOpen) }));
      } else {
        set({ isOpen: arg });
      }
    },
  }))
);

const useKeyboardShortcutsPaneState = () => {
  const { isOpen, setIsOpen } = useKeyboardShortcutsStore.pick();

  return [isOpen, setIsOpen];
};

export default useKeyboardShortcutsPaneState;
